import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import AcceptCreditWrapper from "@components/layouts/acceptcreditWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function CarInjuryJusticeHome(): ReactElement {
    return (
        <AcceptCreditWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Accept Credit"
                    domain="AcceptCredit.Cards"
                />
            </div>
        </AcceptCreditWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
